var _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeliveryTruck4439(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "42px",
    height: "42px",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 65.745 63.947 H 40.269 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 23.477 V 25.292 c 0 -0.926 -0.753 -1.679 -1.679 -1.679 H 13.093 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 48.973 c 3.131 0 5.679 2.548 5.679 5.679 v 36.655 C 67.745 63.052 66.85 63.947 65.745 63.947 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "white",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 27.389 63.947 H 13.093 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 14.295 c 1.104 0 2 0.896 2 2 S 28.493 63.947 27.389 63.947 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "white",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 83.897 63.947 H 82.74 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 1.157 c 1.159 0 2.103 -0.943 2.103 -2.103 V 39.502 c 0 -2.155 -0.967 -4.16 -2.653 -5.501 l -5.252 -4.177 c -1.238 -0.986 -2.792 -1.528 -4.375 -1.528 h -5.975 v 31.651 h 2.115 c 1.104 0 2 0.896 2 2 s -0.896 2 -2 2 h -4.115 c -1.104 0 -2 -0.896 -2 -2 V 26.296 c 0 -1.104 0.896 -2 2 -2 h 7.975 c 2.483 0 4.922 0.852 6.865 2.398 l 5.252 4.176 C 88.482 32.976 90 36.122 90 39.502 v 18.342 C 90 61.21 87.263 63.947 83.897 63.947 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "white",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 88 46.343 H 75.345 c -2.413 0 -4.376 -1.962 -4.376 -4.375 V 26.296 c 0 -1.104 0.896 -2 2 -2 s 2 0.896 2 2 v 15.671 c 0 0.207 0.169 0.375 0.376 0.375 H 88 c 1.104 0 2 0.896 2 2 S 89.104 46.343 88 46.343 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "white",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 33.829 70.387 c -4.654 0 -8.44 -3.786 -8.44 -8.439 c 0 -4.654 3.786 -8.44 8.44 -8.44 s 8.44 3.786 8.44 8.44 C 42.269 66.601 38.482 70.387 33.829 70.387 z M 33.829 57.507 c -2.448 0 -4.44 1.992 -4.44 4.44 s 1.992 4.439 4.44 4.439 s 4.44 -1.991 4.44 -4.439 S 36.277 57.507 33.829 57.507 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "white",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 76.301 70.387 c -4.654 0 -8.44 -3.786 -8.44 -8.439 c 0 -4.654 3.786 -8.44 8.44 -8.44 c 4.653 0 8.439 3.786 8.439 8.44 C 84.74 66.601 80.954 70.387 76.301 70.387 z M 76.301 57.507 c -2.448 0 -4.44 1.992 -4.44 4.44 s 1.992 4.439 4.44 4.439 s 4.439 -1.991 4.439 -4.439 S 78.749 57.507 76.301 57.507 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "white",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65.745 51.788 H 33.829 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 31.917 c 1.104 0 2 0.896 2 2 S 66.85 51.788 65.745 51.788 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "white",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 88 51.788 h -8.641 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 H 88 c 1.104 0 2 0.896 2 2 S 89.104 51.788 88 51.788 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "white",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.834,
    cy: 61.944,
    r: 1.634,
    style: {
      stroke: "white",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "white",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.304,
    cy: 61.944,
    r: 1.634,
    style: {
      stroke: "white",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "white",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 83.897 63.947 H 82.74 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 1.157 c 1.159 0 2.103 -0.943 2.103 -2.103 V 39.502 c 0 -2.155 -0.967 -4.16 -2.653 -5.501 l -5.252 -4.177 c -1.238 -0.986 -2.792 -1.528 -4.375 -1.528 h -5.975 v 31.651 h 2.115 c 1.104 0 2 0.896 2 2 s -0.896 2 -2 2 h -4.115 c -1.104 0 -2 -0.896 -2 -2 V 26.296 c 0 -1.104 0.896 -2 2 -2 h 7.975 c 2.483 0 4.922 0.852 6.865 2.398 l 5.252 4.176 C 88.482 32.976 90 36.122 90 39.502 v 18.342 C 90 61.21 87.263 63.947 83.897 63.947 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "white",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 24.021 51.788 H 2.165 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 21.856 c 1.104 0 2 0.896 2 2 S 25.125 51.788 24.021 51.788 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "white",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45.165 36.186 H 2 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 43.165 c 1.104 0 2 0.896 2 2 S 46.27 36.186 45.165 36.186 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "white",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65.745 36.186 H 55.228 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 10.518 c 1.104 0 2 0.896 2 2 S 66.85 36.186 65.745 36.186 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "white",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryTruck4439);
export default __webpack_public_path__ + "static/media/delivery-truck-4439.e39b35ec33f33f448730ac58d56a8648.svg";
export { ForwardRef as ReactComponent };